import { Box, type SxProps, Typography, useTheme } from "@mui/material";
import { type ReactNode, useContext } from "react";

import { AppContext } from "@/models/AppStateProvider.tsx";
import { UxContext } from "@/models/UxStateProvider";
import { drawerOpenStyles } from "./SBAppBar";

export default function ContextualFooter({
  children,
  sx,
  containerSx,
}: {
  children: ReactNode | ReactNode[];
  sx?: SxProps;
  containerSx?: SxProps;
}) {
  const theme = useTheme();
  const { flags } = useContext(AppContext);
  const { isSmUp, leftNavOpen, rightNavOpen } = useContext(UxContext);
  const _drawerOpenStyles = {
    ...drawerOpenStyles({
      isSmUp,
      leftNavOpen,
      rightNavOpen,
      theme,
    }),
  };

  if (flags.newDesign) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "var(--color-zinc-900)",
          color: "var(--color-zinc-400)",
          borderRadius: 1,
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "fixed",
          left: 0,
          bottom: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "85px",
          zIndex: 1100,
          ..._drawerOpenStyles,
          ...containerSx,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            position: "relative",
            background: theme.palette.secondary.main,
            boxShadow: "0px 2px 8px 0px rgba(4, 7, 5, 0.25)",
            borderRadius: "16px",
            px: 3,
            py: 0.5,
            minHeight: 34,
            width: "100%",
            maxWidth: "300px",
            ...sx,
          }}
        >
          <Typography
            component="div"
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            <>{children}</>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
